<template>
  <div id="login_div">
    <v-container>
      <v-slide-y-transition mode="out-in">
        <v-row :align="alignment" :justify="justify">

          <v-col cols="12">
            <p class="text-center">
              <img src="@/assets/logo_infilesign_white.png" alt="Infile Sign">
            </p>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="elevation-12">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-text-field 
                    v-model="name" 
                    prepend-icon="person" 
                    :rules="nameRules" 
                    id="inputName"
                    label="Nombre" required>
                    </v-text-field>
                  <v-text-field 
                    v-model="lastname" 
                    prepend-icon="person" 
                    :rules="lastnameRules" 
                    id="inputLastname"
                    label="Apellido" required>
                    </v-text-field>

                    <v-text-field 
                    v-model="email" 
                    prepend-icon="email" 
                    :rules="emailRules" 
                    type="email"
                    id="inputEmail"
                    label="Correo" required>
                    </v-text-field>

                    <v-text-field
                      v-model="password"
                      prepend-icon="lock"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      name="input-10-1"
                      label="Contraseña"
                      id="inputPass"
                      hint="At least 8 characters"
                      counter
                      @click:append="show1 = !show1"
                      ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn text :to="{name: 'login'}" class="mr-4" color="info">Inicio sesión</v-btn>
                  <v-spacer />
                  <v-btn :disabled="!valid" color="primary" id="register" class="mr-4" @click="validate">
                    Registrar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-slide-y-transition>
    </v-container>
  </div>
</template>
<script>
  export default {
    props: {
      quote: String,
      author: String,
    },
  	data: function() {
  	  return {
  	      valid: true,
          userExist: false,
          justify: 'center',
          alignment: 'center',
  	      name: '',
  	      nameRules: [v => !!v || 'Campo requerido',],
  	      lastname: '',
  	      lastnameRules: [v => !!v || 'Campo requerido',],
  	      password: "",
  	      email: '',
  	      emailRules: [
  	        v => !!v || 'Campo requerido',
  	        v => /.+@.+\..+/.test(v) || 'Correo debe ser valido',
  	      ],
  		    show1: false,
          password: '',
          rules: {
            required: value => !!value || 'Requerido.',
            min: v => v.length >= 8 || 'Min 8 caracteres',
            emailMatch: () => ('The email and password you entered don\'t match'),
          },
  
  	  };
  	},
    computed: {
  
    },
    mounted() {
      $("#inputName, #inputLastname, #inputPass, #inputEmail").keyup(function(event) {
        if (event.keyCode === 13) {
          $("#register").click();
        }
      });
    },
    methods: {
       validate () {
          if (this.$refs.form.validate()) {
            this.snackbar = true;
            this.$store.dispatch('REGISTER', {
              email: this.email,
              password: this.password,
              nombre: this.name,
              apellido: this.lastname
            })
            .then(({status}) => {
              console.log("register... true");
              this.$router.push("/login");
            })
            .catch(error => {
              this.error = true;
              this.userExist = true;
              console.log("error register");
              console.log(error);
            })
          }
        },
        reset () {
          this.$refs.form.reset()
        },
        resetValidation () {
          this.$refs.form.resetValidation()
        },
    },
  };
</script>